
<style scoped>
    .detail{width:57.2916666667vw;margin:4.6875vw auto auto;padding-bottom:5.2083333333vw;padding-top:4.1666666667vw}
    .detail .det_header{margin:0 1.0416666667vw;padding-bottom:1.25vw;border-bottom:1px solid #d0d0d0}
    .detail .header-tip{color:#969696;font-size:.9375vw;margin-bottom:2.2916666667vw}
    .detail .header-title{font-size:2.0833333333vw;color:#404040;font-weight:500;text-align:center;margin-bottom:2.1875vw}
    .detail .header-sub-title{color:#969696;font-size:.9375vw}
    .detail .dialog-body{padding-top:2.1875vw;color:#515151;font-size:1.1458333333vw;line-height:2em}
    .detail .dialog-body .top-box{text-indent:2em}
    .detail .dialog-body .img-box{display:flex;justify-content:center;margin:2.3958333333vw 0}
    .detail .dialog-body .img-box img{width:27.3958333333vw;height:16.9270833333vw;-o-object-fit:cover;object-fit:cover}
    @media screen and (max-width: 1024px){
      .detail{width:100%;padding-top:10.1666666667vw;}
      .detail .header-tip{font-size:12px;}
      .detail .header-title{font-size:14px;}
      .detail .header-sub-title{font-size:12px;}
      .detail .dialog-body{font-size:12px;min-height:300px}
    }
</style>

<template>
  <div class="detail page" v-if="content">
      <div class="det_header">
          <div class="header-tip">
              Tin tức &gt; {{ content.name}} &gt; Nội dung chính
          </div>
          <div class="header-title">
              {{ content.title}}
          </div>
          <div class="header-sub-title">
              {{ content.date ? content.date.split(' ')[0] : '' }} Nguồn: {{ content.author}}
          </div>
      </div>
      <div class="dialog-body">
          <div class="top-box" v-html="content.content"></div>
      </div>
  </div>
</template>
<script>
import axios from 'axios';
import { BASE_URL } from '@/config';

export default {
  name: 'HelloWorld',
  data() {
    return {
      content: null
    }
  },
  mounted() {
    const id = this.$route.params.id;
    axios.get(`${BASE_URL}/index/index/news?lang=vn`, {
      params: { id }
    }).then(res => {
      if (res.data && res.data.content) {
        this.content = res.data.content;
      }
    });
    // 菜单高亮
    const menu = document.querySelector('.menu');
    if (menu) {
      const menuItems = menu.querySelectorAll('.menu-item');
      menuItems.forEach(item => {
        const linkDiv = item.querySelector('.menu-item-link');
        const aTag = linkDiv ? linkDiv.querySelector('a') : null;
        if (linkDiv && aTag) {
          if (aTag.getAttribute('href') === 'news') {
            linkDiv.classList.add('active-route');
          } else {
            linkDiv.classList.remove('active-route');
          }
        }
      });
    }
  }
  
}
</script>